// extracted by mini-css-extract-plugin
export default {"container":"style_container__bzOGJ","fileContainer":"style_fileContainer__o4brB","title":"style_title__KK05e","subtitle":"style_subtitle__wjtj7"};